<template>
  <div
    v-if="thumbnail !== null"
    class="max-w-full mx-auto px-4 sm:py-24 sm:px-6 lg:px-8 py-16"
  >
    <div class="relative rounded-lg overflow-hidden">
      <div class="absolute inset-0">
        <img
          :src="thumbnail"
          :alt="buttonText"
          class="w-full h-full object-center object-cover"
        />
      </div>
      <div
        class="relative bg-gray-900 bg-opacity-75 py-32 px-6 sm:py-40 sm:px-12 lg:px-16"
      >
        <div
          class="relative max-w-3xl mx-auto flex flex-col items-center text-center"
        >
          <button
            class="button-primary mt-4 mb-4 block mx-auto lg:w-[335px] md:w-[335px] min-h-[60px]"
            @click="openModal = true"
          >
            <span v-if="buttonText !== null">
              {{ buttonText }}
            </span>
            <span v-else>
              {{ $t("media.cell.video") }}
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div v-if="thumbnail === null" class="flex justify-center">
    <ButtonContentSection
      v-if="buttonText === null"
      :label="$t('media.cell.video')"
      :icon="PlayIcon"
      @click="openModal = true"
    />
    <ButtonContentSection
      v-else
      :label="buttonText"
      :icon="PlayIcon"
      @click="openModal = true"
    />
  </div>

  <TransitionRoot as="template" :show="openModal">
    <Dialog as="div" class="relative z-10" @close="openModal = false">
      <TransitionChild
        as="template"
        enter="ease-out duration-300"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="ease-in duration-200"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div
          class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
        />
      </TransitionChild>

      <div class="fixed z-10 inset-0">
        <div
          class="flex items-center sm:items-center justify-center min-h-full p-4 text-center sm:p-0"
        >
          <TransitionChild
            as="template"
            enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <DialogPanel
              class="relative overflow-hidden transform transition-all sm:my-8 lg:max-w-3/5 sm:p-6"
            >
              <video
                :key="video"
                controls
                class="shadow-xl rounded-3xl w-[900px] max-h-[90vh]"
              >
                <source :src="video" />
              </video>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>
import {
  Dialog,
  DialogPanel,
  TransitionChild,
  TransitionRoot,
} from "@headlessui/vue";
import ButtonContentSection from "~/components/v2/layout/button/ButtonContentSection.vue";
import PlayIcon from "../icon/PlayIcon.vue";

export default {
  name: "VideoModal",
  components: {
    ButtonContentSection,
    Dialog,
    DialogPanel,
    TransitionChild,
    TransitionRoot,
  },
  props: {
    thumbnail: String,
    buttonText: String,
    video: String,
  },
  data() {
    return {
      openModal: false,
    };
  },
  computed: {
    PlayIcon() {
      return PlayIcon;
    },
  },
};
</script>
